import React from 'react'
import './Loader.css'
/**
* @author
* @function Loader
**/

const Loader = (props) => {
    return (
        <div className="loaderDiv">
            <div className="loader"></div>
        </div>
    )

}

export default Loader